export const NUM_STARS = 500;
export const NUM_ARMS = 4;

export const GALAXY_THICKNESS = 5;

export const CORE_X_DIST = 33;
export const CORE_Y_DIST = 33;

export const OUTER_CORE_X_DIST = 100;
export const OUTER_CORE_Y_DIST = 100;

export const ARM_X_DIST = 100;
export const ARM_Y_DIST = 50;
export const ARM_X_MEAN = 200;
export const ARM_Y_MEAN = 100;

export const SPIRAL = 3.0;
export const ARMS = 2.0;

export const HAZE_RATIO = 0.5;
